// extracted by mini-css-extract-plugin
export default {"iconPremium":"IconPremium_iconPremium__TUNBa","bg":"IconPremium_bg__NyEy1"};